import React from "react"
import PropTypes from "prop-types"

const SaveIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 14 20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 2v16a1 1 0 0 0 1.596.803l4.029-2.992a1 1 0 0 1 1.223.024l3.524 2.841A1 1 0 0 0 13 17.898V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1z"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      fillRule="evenodd" />
  </svg>
)

SaveIcon.propTypes = {
  style: PropTypes.object
}

export default SaveIcon



// WEBPACK FOOTER //
// ./src/components/icons/save-icon.jsx